import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";
import { api } from "@/lib/api";
import { queryClient } from "@/lib/query-client";

export const Route = createFileRoute("/_auth/admin")({
  beforeLoad: async () => {
    // El layout padre _auth ya garantiza autenticación. Aquí filtramos por rol.
    const me = await queryClient.fetchQuery({ queryKey: ["me"], queryFn: () => api.me() });
    if (me.role !== "superadmin") {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: () => <Outlet />,
});
